function y(e, t) {
  var r = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(e);
    t && (n = n.filter(function(l) {
      return Object.getOwnPropertyDescriptor(e, l).enumerable;
    })), r.push.apply(r, n);
  }
  return r;
}
function d(e) {
  for (var t = 1; t < arguments.length; t++) {
    var r = arguments[t] != null ? arguments[t] : {};
    t % 2 ? y(Object(r), !0).forEach(function(n) {
      m(e, n, r[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : y(Object(r)).forEach(function(n) {
      Object.defineProperty(e, n, Object.getOwnPropertyDescriptor(r, n));
    });
  }
  return e;
}
function O(e) {
  var t = function(r, n) {
    if (typeof r != "object" || !r) return r;
    var l = r[Symbol.toPrimitive];
    if (l !== void 0) {
      var i = l.call(r, n || "default");
      if (typeof i != "object") return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (n === "string" ? String : Number)(r);
  }(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function m(e, t, r) {
  return (t = O(t)) in e ? Object.defineProperty(e, t, { value: r, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = r, e;
}
function b() {
  return b = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r) Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, b.apply(this, arguments);
}
function j(e, t) {
  if (e == null) return {};
  var r, n, l = function(c, a) {
    if (c == null) return {};
    var o, u, s = {}, f = Object.keys(c);
    for (u = 0; u < f.length; u++) o = f[u], a.indexOf(o) >= 0 || (s[o] = c[o]);
    return s;
  }(e, t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (n = 0; n < i.length; n++) r = i[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (l[r] = e[r]);
  }
  return l;
}
function v(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var r = 0, n = new Array(t); r < t; r++) n[r] = e[r];
  return n;
}
function g(e, t) {
  var r = typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (!r) {
    if (Array.isArray(e) || (r = function(o, u) {
      if (o) {
        if (typeof o == "string") return v(o, u);
        var s = Object.prototype.toString.call(o).slice(8, -1);
        return s === "Object" && o.constructor && (s = o.constructor.name), s === "Map" || s === "Set" ? Array.from(o) : s === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(s) ? v(o, u) : void 0;
      }
    }(e)) || t) {
      r && (e = r);
      var n = 0, l = function() {
      };
      return { s: l, n: function() {
        return n >= e.length ? { done: !0 } : { done: !1, value: e[n++] };
      }, e: function(o) {
        throw o;
      }, f: l };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i, c = !0, a = !1;
  return { s: function() {
    r = r.call(e);
  }, n: function() {
    var o = r.next();
    return c = o.done, o;
  }, e: function(o) {
    a = !0, i = o;
  }, f: function() {
    try {
      c || r.return == null || r.return();
    } finally {
      if (a) throw i;
    }
  } };
}
function w(e, t) {
  var r, n = t.replacementChars, l = t.replacement, i = t.separate, c = n, a = "", o = g(e);
  try {
    for (o.s(); !(r = o.n()).done; ) {
      var u, s = r.value, f = !Object.prototype.hasOwnProperty.call(l, s) && ((u = l[c[0]]) === null || u === void 0 ? void 0 : u.test(s));
      (i && s === c[0] || f) && (c = c.slice(1), a += s);
    }
  } catch (p) {
    o.e(p);
  } finally {
    o.f();
  }
  return a;
}
function h(e) {
  return e.length > 0 ? m({}, e, /./) : {};
}
function P(e, t) {
  var r, n = t.mask, l = t.replacement, i = t.showMask, c = 0, a = "", o = g(n);
  try {
    for (o.s(); !(r = o.n()).done; ) {
      var u = r.value;
      if (!i && e[c] === void 0) break;
      Object.prototype.hasOwnProperty.call(l, u) && e[c] !== void 0 ? a += e[c++] : a += u;
    }
  } catch (s) {
    o.e(s);
  } finally {
    o.f();
  }
  return a;
}
function S(e, t) {
  for (var r = t.mask, n = t.replacement, l = [], i = 0; i < r.length; i++) {
    var c, a = (c = e[i]) !== null && c !== void 0 ? c : r[i], o = Object.prototype.hasOwnProperty.call(n, a) ? "replacement" : e[i] !== void 0 && e[i] !== r[i] ? "input" : "mask";
    l.push({ type: o, value: a, index: i });
  }
  return l;
}
function k(e, t) {
  for (var r = t.start, n = r === void 0 ? 0 : r, l = t.end, i = t.mask, c = t.replacement, a = t.separate, o = e.slice(n, l), u = i.slice(n, l), s = "", f = 0; f < u.length; f++) {
    var p = Object.prototype.hasOwnProperty.call(c, u[f]);
    p && o[f] !== void 0 && o[f] !== u[f] ? s += o[f] : p && a && (s += u[f]);
  }
  return s;
}
function A(e) {
  for (var t = e.mask, r = e.replacement, n = arguments.length > 1 && arguments[1] !== void 0 && arguments[1], l = typeof r == "string" ? h(r) : r, i = ["[", "]", "\\", "/", "^", "$", ".", "|", "?", "*", "+", "(", ")", "{", "}"], c = "", a = 0; a < t.length; a++) {
    var o = Object.prototype.hasOwnProperty.call(l, t[a]), u = n ? "(?!".concat(t[a], ")") : "";
    a === 0 && (c += "^"), c += o ? "".concat(u, "(").concat(l[t[a]].toString().slice(1, -1), ")") : i.includes(t[a]) ? "\\".concat(t[a]) : t[a], a === t.length - 1 && (c += "$");
  }
  return c;
}
export {
  j as _,
  b,
  P as c,
  S as d,
  h as e,
  A as g,
  k as h,
  w as i,
  d as j
};
//# sourceMappingURL=helpers-CA92ST8-.js.map
